const availableToShow = (envKey?: string): boolean => {
  return !envKey || (envKey && window.configs[envKey] === 'true');
};

export default { availableToShow };
